import { combineReducers } from "redux";

import LanguageReducer from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageReducer";
import UserReducer from "./Reducers/UserReducer";
import SessionReducer from "./Reducers/SessionReducer";
import WhiteboardReducer from "./Reducers/WhiteboardReducer";
import RoomMetaDataReducer from "./Reducers/RoomMetaDataReducer";
import ChatReducer from "./Reducers/ChatReducer";
import ParticipantReducer from "./Reducers/ParticipantReducer";
import TostMessageReducer from "./Reducers/TostMessageReducer";
import LocationReducer from "./Reducers/LocationReducer";
import AppEmulationReducer from "./Reducers/AppEmulationReducer";
import OrganisationReducer from "./Reducers/OrganisationReducer";
import ErrorReducer from "./Reducers/ErrorReducer";
import QrReducer from "./Reducers/QrReducer";
import SnapshotReducer from "./Reducers/SnapshotReducer";
import AdminReducer from "./Reducers/AdminReducer";
import TestPageReducer from "./Reducers/TestPageReducer";
import CustomerCoBrowseReducer from "./Reducers/CustomerCoBrowseReducer";
import InboundCoBrowseReducer from "./Reducers/InboundCoBrowseReducer";
import SupportCenterReducer from './Reducers/SupportCenterReducer';

const appReducers = combineReducers({
  UserReducer,
  SessionReducer,
  WhiteboardReducer,
  LanguageReducer,
  RoomMetaDataReducer,
  ChatReducer,
  ParticipantReducer,
  TostMessageReducer,
  LocationReducer,
  AppEmulationReducer,
  OrganisationReducer,
  ErrorReducer,
  QrReducer,
  SnapshotReducer,
  AdminReducer,
  TestPageReducer,
  CustomerCoBrowseReducer,
  InboundCoBrowseReducer,
  SupportCenterReducer
});

const rootReducer = (state, action) => {
  return appReducers(state, action);
};

export default rootReducer;
